import React from 'react';

/**
 * SearchInput
 * ------------------------------------------------------------------
 * Text input with a leading search icon, used for "Search by Project
 * Title..." style filters. Controlled component.
 *
 * @param {string} value
 * @param {function} onChange - receives the native change event
 * @param {string} placeholder
 * @param {string} iconSrc - path to the search icon image
 */
const SearchInput = ({ value, onChange, placeholder = 'Search...', iconSrc, className = '' }) => (
  <label className={`search-input ${className}`}>
    <img src={iconSrc} alt="" className="search-input__icon" />
    <input
      type="text"
      className="search-input__field"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  </label>
);

export default SearchInput;